export default __webpack_public_path__ + "static/stickingin-4247b9316ab6802fb8f0603debd1613e.png";